import { useToastStore } from '../stores/toast.store';

const ICONS = { success: '✓', error: '✕', info: 'ℹ' };
const STYLES = {
  success: 'from-emerald-500 to-green-600 shadow-[0_8px_30px_rgba(5,150,105,0.4)]',
  error:   'from-rose-500 to-red-600 shadow-[0_8px_30px_rgba(225,29,72,0.4)]',
  info:    'from-slate-700 to-slate-900 shadow-[0_8px_30px_rgba(15,23,42,0.35)]',
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-2 z-50 max-w-md">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`bg-gradient-to-br ${STYLES[t.kind]} text-white rounded-2xl px-4 py-3 text-sm flex items-start gap-3 backdrop-blur-xl animate-[slideIn_0.25s_ease-out]`}
        >
          <span className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center text-xs shrink-0">
            {ICONS[t.kind]}
          </span>
          <span className="flex-1 whitespace-pre-wrap leading-snug">{t.text}</span>
          <button
            onClick={() => dismiss(t.id)}
            className="opacity-70 hover:opacity-100 text-xs transition"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
